import { FONT_FAMILIES as L, DISALLOWED_COLOR_VALUES as O, BLOCK_CLASSES as h } from "../../constants.js";
import c from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
function b(r) {
  let e = "";
  return r.attrs.paddingTop && (e += `padding-top: ${r.attrs.paddingTop}; `), r.attrs.paddingBottom && (e += `padding-bottom: ${r.attrs.paddingBottom}; `), r.attrs.paddingLeft && (e += `padding-left: ${r.attrs.paddingLeft}; `), r.attrs.paddingRight && (e += `padding-right: ${r.attrs.paddingRight}; `), e;
}
function $(r) {
  var l;
  r.attrs = Object.assign({}, r.attrs, {
    fontFamily: { default: "" },
    fontColor: { default: "" },
    backgroundColor: { default: "" },
    paddingTop: { default: "" },
    paddingBottom: { default: "" },
    paddingLeft: { default: "" },
    paddingRight: { default: "" },
    borderRadius: { default: "" },
    borderColor: { default: "" },
    borderWidth: { default: "" },
    borderStyle: { default: "" }
  }), (l = r.parseDOM) == null || l.forEach(function(t) {
    let s = t.getAttrs;
    t.getAttrs = (i) => {
      let a = {};
      s && Object.assign(a, s(i));
      let {
        fontFamily: d,
        color: o,
        borderRadius: f,
        paddingTop: g,
        paddingBottom: p,
        paddingLeft: u,
        paddingRight: y
      } = i == null ? void 0 : i.style;
      if (d && L.includes(d) && Object.assign(a, { fontFamily: d }), o && !O.includes(o) && c(o).isValid()) {
        let n = c(o).toHexString();
        Object.assign(a, { fontColor: n });
      }
      if ((g || u || y || p) && Object.assign(a, { paddingTop: g, paddingLeft: u, paddingRight: y, paddingBottom: p }), f && Object.assign(a, { borderRadius: f }), i.classList.contains(h.button) || i.classList.contains("intercom-interblocks-button")) {
        let n = C(i.firstChild);
        Object.assign(a, n);
      }
      return a;
    };
  });
  let e = r.toDOM;
  return r.toDOM = (t) => {
    if (!e)
      throw new Error("must specify a toDOM method");
    let s = e(t);
    if (s.length < 2)
      throw new Error("must specify at least two elements in output spec");
    s[1] === 0 && s.splice(1, 0, {});
    let i = s[1], a = s[2] ? s[2][1] : {};
    return i.style || (i.style = ""), a.style || (a.style = ""), t.attrs.fontFamily && (i.style += `font-family: ${t.attrs.fontFamily}; `), t.attrs.borderRadius && (a.style += `border-radius: ${t.attrs.borderRadius}; `), t.attrs.fontColor && (i.style += `color: ${t.attrs.fontColor}; `), t.attrs.backgroundColor && (t.attrs.responsive ? a.style += `background-color: ${t.attrs.backgroundColor}; ` : t.type.name !== "button" && !t.attrs.container && (i.style += `background-color: ${t.attrs.backgroundColor}; `)), t.attrs.borderColor && (i.style += `border-color: ${t.attrs.borderColor}; `), m(t) && (t.attrs.container ? i.style += b(t) : (a.style += b(t), t.attrs.responsive && (a.style += "border-collapse: separate; "))), i.style = i.style.trim(), a.style = a.style.trim(), i.style === "" && (i.style = null), a.style === "" && (a.style = null), s;
  }, r;
}
function C(r) {
  let {
    paddingTop: e,
    paddingRight: l,
    paddingLeft: t,
    paddingBottom: s,
    borderRadius: i,
    borderColor: a,
    borderWidth: d,
    borderStyle: o
  } = r == null ? void 0 : r.style;
  return {
    paddingTop: e,
    paddingRight: l,
    paddingLeft: t,
    paddingBottom: s,
    borderRadius: i,
    borderColor: a,
    borderWidth: d,
    borderStyle: o
  };
}
function m(r) {
  let { paddingTop: e, paddingRight: l, paddingLeft: t, paddingBottom: s } = r.attrs;
  return e || l || t || s;
}
export {
  b as getPaddingStyles,
  $ as stylable
};
